import { useEffect, useRef } from "react";
import { getAdminCredentials } from "../Api/AdminApi";

const events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];

const AppLogout = ({ children }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    let applyInactivityControl = true;

    const logoutAction = () => {
      localStorage.clear();
      window.location.pathname = "/login";
    };

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      startTimer();
    };

    const startTimer = () => {
      timerRef.current = setTimeout(() => {
        cleanup();
        logoutAction();
      }, 900000); // 15 minutos
    };

    const cleanup = () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };

    const init = async () => {
      try {
        const userdata = await getAdminCredentials();
        console.log("userdata", userdata);

        // Solo activar el control si no es tipo 0 ni 1
        if (userdata?.IdTipoUsuario === "0" || userdata?.IdTipoUsuario === "1") {
          applyInactivityControl = false;
          return;
        }

        // Activar listeners y timer
        events.forEach((event) => {
          window.addEventListener(event, resetTimer);
        });
        startTimer();
      } catch (error) {
        console.error("Error obteniendo credenciales:", error);
      }
    };

    init();

    return () => {
      if (applyInactivityControl) {
        cleanup();
      }
    };
  }, []);

  return children;
};

export default AppLogout;
